<template>
  <b-card no-body>
    <h4 class="pl-1 pt-1">Restante</h4>
    <b-table striped hover :items="items" :fields="fields" small> </b-table>
  </b-card>
</template>

<script>
export default {
  name: "RestList",
  data() {
    return {
      fields: [{ key: "rest", label: "Kgs", class: "text-center" }]
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped></style>
